import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { api } from "@/lib/api";

export type User = any;
type Ctx = { user: User | null | false; setUser: (u: User | false) => void; refresh: () => Promise<void>; logout: () => Promise<void> };
const AuthCtx = createContext<Ctx>(null as any);

export function AuthProvider({ children }: { children: React.ReactNode }) {
  const [user, setUser] = useState<User | null | false>(null);
  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setUser(false);
    }
  }, []);
  useEffect(() => {
    // Returning from Google: AuthCallback exchanges the session first.
    if (window.location.hash?.includes("session_id=")) return;
    refresh();
  }, [refresh]);
  const logout = useCallback(async () => {
    await api.post("/auth/logout").catch(() => {});
    setUser(false);
  }, []);
  const value = useMemo(() => ({ user, setUser, refresh, logout }), [user, refresh, logout]);
  return <AuthCtx.Provider value={value}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
